export const GET_APPROVALS_COUNT = 'CBRE-GET-APPROVALS-COUNT';
export const SET_APPROVALS_COUNT = 'CBRE-SET-APPROVALS-COUNT';
export const GET_APPROVALS_LIST = 'CBRE-GET-APPROVALS-LIST';
export const SET_APPROVALS_LIST = 'CBRE-SET-APPROVALS-LIST';